document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.dimensions-wrapper');
    if (!wrapper) return;

    // Works for any product type (Mattress, Bedding, etc.)
    const widthSelect = document.querySelector('#width');
    if (!widthSelect) return;

    // Try to find the Width option group inside the variant picker
    const widthOptionGroup = document.querySelector('variant-selects [data-option-name="Width"]');
    
    // Fallback: if the theme does NOT use data-option-name,
    // find a fieldset that contains “Width” in its text
    const fallbackGroup = Array.from(document.querySelectorAll('variant-selects fieldset'))
        .find(fs => fs.innerText.trim().toLowerCase().includes('width'));

    const widthGroup = widthOptionGroup || fallbackGroup;
    if (!widthGroup) {
        console.warn('Width option group not found');
        return;
    }

    // Determine which variant title corresponds to the selected numeric width
    function getVariantFromWidth(width) {
        if (width >= 25 && width <= 38) return "25-38W";
        if (width >= 39 && width <= 54) return "39-54W";
        if (width >= 55 && width <= 60) return "55-60W";
        if (width >= 61 && width <= 76) return "61-76W";
        return null;
    }

    function updateSelectedVariant() {
        const width = parseInt(widthSelect.value, 10);
        const variantValue = getVariantFromWidth(width);
        if (!variantValue) return;

        // Find all radio buttons inside the Width variant group
        const radioButtons = widthGroup.querySelectorAll('input[type="radio"]');

        radioButtons.forEach(radio => {
            if (radio.value.trim() === variantValue) {
                radio.checked = true;

                // Very important — trigger the change event so Shopify updates the price
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    widthSelect.addEventListener('change', updateSelectedVariant);

    // Run on initial page load
    updateSelectedVariant();
});
